import type { ReactNode } from 'react';

interface PageLayoutProps {
  /** Content rendered inside the top bar (h-20) */
  topBar: ReactNode;
  /** Content rendered inside the bottom bar */
  bottomBar?: ReactNode;
  /** Extra className on the scrollable content area (default: padded like AppLayout) */
  contentClassName?: string;
  /** Page content — scrollable area between top bar and bottom bar */
  children: ReactNode;
}

export function PageLayout({
  topBar,
  bottomBar,
  contentClassName = 'flex-1 overflow-y-auto p-4 sm:p-6',
  children,
}: PageLayoutProps) {
  return (
    <div className="flex h-full min-h-dvh flex-col">
      {/* Top bar — h-20 + safe area top for fullscreen pages (messaging) */}
      <header className="flex-shrink-0 glass-surface-nav pt-safe">
        <div className="flex h-20 items-center gap-3 px-4">{topBar}</div>
      </header>

      {/* Scrollable content */}
      <main className={contentClassName}>
        {children}
      </main>

      {/* Bottom bar */}
      {bottomBar && (
        <nav className="flex-shrink-0 glass-surface-nav pb-safe">
          {bottomBar}
        </nav>
      )}
    </div>
  );
}
